
// TODO: Move to `react-native-ios-utilities`
export type UIEdgeInsets = {
  top: number;
  left: number;
  bottom: number;
  right: number;
};

export type UIOffset = {
  horizontal?: number;
  vertical?: number;
};